import React from 'react';

export const UnusualWayGlow = () => (
    <svg
        preserveAspectRatio="none"
        width="100%"
        height="100%"
        overflow="visible"
        viewBox="0 0 2632.56 1350.25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        style={{ display: 'block', pointerEvents: 'none' }}
    >
        <g id="Group 1597879537">
            <g id="Ellipse 1068" filter="url(#filter0_f_2758_1213)">
                <ellipse
                    cx="1316.28"
                    cy="609.73"
                    rx="488.72"
                    ry="1195.27"
                    transform="rotate(90 1316.28 609.73)"
                    fill="var(--fill-0, #254200)"
                />
            </g>
            <g id="Ellipse 1066" filter="url(#filter1_fn_2758_1213)">
                <ellipse
                    cx="1316.28"
                    cy="609.73"
                    rx="488.72"
                    ry="1195.27"
                    transform="rotate(90 1316.28 609.73)"
                    fill="var(--fill-0, #F1F4CB)"
                />
            </g>
            <g id="Ellipse 1064" filter="url(#filter2_fn_2758_1213)">
                <ellipse
                    cx="1316.27"
                    cy="614.812"
                    rx="420.572"
                    ry="1028.6"
                    transform="rotate(90 1316.27 614.812)"
                    fill="var(--fill-0, #254200)"
                />
            </g>
            <g id="Ellipse 1070" filter="url(#filter3_f_2758_1213)">
                <ellipse
                    cx="1316.27"
                    cy="778.418"
                    rx="420.572"
                    ry="1028.6"
                    transform="rotate(90 1316.27 778.418)"
                    fill="var(--fill-0, black)"
                />
            </g>
        </g>
        <defs>
            <filter
                id="filter0_f_2758_1213"
                x="-3.04903e-06"
                y="-2.86836e-06"
                width="2632.56"
                height="1219.46"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="60.5049" result="effect1_foregroundBlur_2758_1213" />
            </filter>
            <filter
                id="filter1_fn_2758_1213"
                x="90.7574"
                y="90.7574"
                width="2451.05"
                height="1037.95"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="15.1262" result="effect1_foregroundBlur_2758_1213" />
                <feTurbulence
                    type="fractalNoise"
                    baseFrequency="2 2"
                    stitchTiles="stitch"
                    numOctaves="3"
                    result="noise"
                    seed="9119"
                />
                <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
                <feComponentTransfer in="alphaNoise" result="coloredNoise1">
                    <feFuncA
                        type="discrete"
                        tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
                    />
                </feComponentTransfer>
                <feComposite
                    operator="in"
                    in2="effect1_foregroundBlur_2758_1213"
                    in="coloredNoise1"
                    result="noise1Clipped"
                />
                <feComponentTransfer in="alphaNoise" result="coloredNoise2">
                    <feFuncA
                        type="discrete"
                        tableValues="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 "
                    />
                </feComponentTransfer>
                <feComposite
                    operator="in"
                    in2="effect1_foregroundBlur_2758_1213"
                    in="coloredNoise2"
                    result="noise2Clipped"
                />
                <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
                <feComposite operator="in" in2="noise1Clipped" in="color1Flood" result="color1" />
                <feFlood floodColor="rgba(255, 255, 255, 0.25)" result="color2Flood" />
                <feComposite operator="in" in2="noise2Clipped" in="color2Flood" result="color2" />
                <feMerge result="effect2_noise_2758_1213">
                    <feMergeNode in="effect1_foregroundBlur_2758_1213" />
                    <feMergeNode in="color1" />
                    <feMergeNode in="color2" />
                </feMerge>
            </filter>
            <filter
                id="filter2_fn_2758_1213"
                x="136.407"
                y="42.9769"
                width="2359.73"
                height="1143.67"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="75.6312" result="effect1_foregroundBlur_2758_1213" />
                <feTurbulence
                    type="fractalNoise"
                    baseFrequency="2 2"
                    stitchTiles="stitch"
                    numOctaves="3"
                    result="noise"
                    seed="4071"
                />
                <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
                <feComponentTransfer in="alphaNoise" result="coloredNoise1">
                    <feFuncA
                        type="discrete"
                        tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
                    />
                </feComponentTransfer>
                <feComposite
                    operator="in"
                    in2="effect1_foregroundBlur_2758_1213"
                    in="coloredNoise1"
                    result="noise1Clipped"
                />
                <feComponentTransfer in="alphaNoise" result="coloredNoise2">
                    <feFuncA
                        type="discrete"
                        tableValues="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 "
                    />
                </feComponentTransfer>
                <feComposite
                    operator="in"
                    in2="effect1_foregroundBlur_2758_1213"
                    in="coloredNoise2"
                    result="noise2Clipped"
                />
                <feFlood floodColor="rgba(0, 0, 0, 0.25)" result="color1Flood" />
                <feComposite operator="in" in2="noise1Clipped" in="color1Flood" result="color1" />
                <feFlood floodColor="rgba(255, 255, 255, 0.25)" result="color2Flood" />
                <feComposite operator="in" in2="noise2Clipped" in="color2Flood" result="color2" />
                <feMerge result="effect2_noise_2758_1213">
                    <feMergeNode in="effect1_foregroundBlur_2758_1213" />
                    <feMergeNode in="color1" />
                    <feMergeNode in="color2" />
                </feMerge>
            </filter>
            <filter
                id="filter3_f_2758_1213"
                x="136.409"
                y="206.583"
                width="2359.73"
                height="1143.67"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feGaussianBlur stdDeviation="75.6312" result="effect1_foregroundBlur_2758_1213" />
            </filter>
        </defs>
    </svg>
);
